import { all } from "@redux-saga/core/effects";
import { brandsEntriesSagas } from "modules/Brands/services/Brands/sagas";
import {brandTrackedDomainsSagas} from "modules/Brands/services/BrandTrackedDomains/sagas";
import {getBrandsWorker} from "services/Brand/sagas";

export function* brandsSaga() {
    yield all([
        getBrandsWorker(),
        brandsEntriesSagas(),
        brandTrackedDomainsSagas()
    ]);
}
